/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
import React from 'react';
import { permissionObj } from '../../../../Helpers/permission';
import SearchFor from '../../../Modals/SearchFor';
import SearchFilterBtn from '../../../../components/buttons/SearchFilterBtn';
import DeleteModal from '../../../Modals/DeleteModal';
import ExportDataBtn from '../../../../components/buttons/ExportDataBtn';
import ImportFileModal from '../../../Modals/ImportFileModal';
import HeadTittle from '../../../../components/HeadTittle';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import {AddIcon, EditIcon, TrashOutlineIcon} from '../../../../components/buttons/IconButtons';
import routes from '../../../../Routes/routes';
import AllVehiclesApp from './Functionality/AllVehiclesApp';
import {VIEW_TYPE} from '../../../../enums/ViewType';
import {USER_ACCESS_KEY_MODEL} from "../../../../enums/userTypeEnum";
import MainVehiclesTable from "./subComponents/MainVehiclesTable";
import MainVehiclesCards from "./subComponents/MainVehiclesCards";

const AllVehicles = () => {
    const {
        deleteSelectedVehicles,
        contractorId,
        supplierId,
        permission,
        t,
        DEV,
        option,
        moduleId,
        criteria,
        setCriteria,
        view, setView,
        selectedList,
        setSelectedList,
        deleteVehicleShow,
        setDeleteVehicleShow,
        filterDialogShow,
        setFilterDialogShow,
        finalArray,
        setFinalArray,
        setLoaded,
        importFileShow,
        setImportFileShow,
        setCreationErrorsShow,
        searchElement,
        setSearchElement,
        bodyForExport,
        setBodyForExport,
        setSimpleSearch,
        search,
        setSearch,
        modified,
        setModified,
        isAllChecked,
        setIsAllChecked,
        showActionsContractorSupplier
    } = AllVehiclesApp();

    return (
        <>
            <HeadTittle name={'vehicle_fleet'} view={view} setView={setView}>
                { (showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_IMPORT)) &&
                    <ButtonAction
                        id='btn_av_import_data'
                        name='import_data'
                        className='btn-icon-accent-450'
                        splitName={false}
                        Icon={EditIcon}
                        onClick={() => {
                            setImportFileShow(true);
                        }}
                    />
                }

                { (showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_EXPORT)) &&
                    <>
                        {search ? (
                            <ExportDataBtn moduleId={moduleId} search={search} body={criteria} option={option} />
                        ) : (
                            <ExportDataBtn moduleId={moduleId} search={search} body={bodyForExport} option={option} />
                        )}
                    </>
                }

                {(showActionsContractorSupplier  || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_CREATE)) && (
                    <ButtonAction
                        id='btn_av_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        url={contractorId !== null ? routes.vehicleContractor.create : supplierId !== null
                            ? routes.vehicleSupplier.create : routes.vehicleFleet.create}
                    />
                )}
                {(showActionsContractorSupplier || DEV || permission?.includes(permissionObj?.WEB_VEHICLE_DELETE)) && (
                    <ButtonAction
                        id='btn_av_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteVehicleShow(true);
                        }}
                    />
                )}
                <SearchFilterBtn finalArray={finalArray}
                    fnclick={() => setFilterDialogShow(true)}
                />
            </HeadTittle>


            {view === VIEW_TYPE.GRID.name && (
                <MainVehiclesCards
                    view={view}
                    selectedList={selectedList}
                    setSelectedList={setSelectedList}
                    moduleId={moduleId}
                    option={option}
                    bodyForExport={bodyForExport}
                    setBodyForExport={setBodyForExport}
                    setSearch={setSearch}
                    setSimpleSearch={setSimpleSearch}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    finalArray={finalArray}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    setCriteria={setCriteria}
                    modified={modified}
                    setModified={setModified}
                    showActionsContractorSupplier={showActionsContractorSupplier}
                />
            )}
            {view === VIEW_TYPE.LIST.name && (
                <MainVehiclesTable
                        view={view}
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        moduleId={moduleId}
                        option={option}
                        bodyForExport={bodyForExport}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        finalArray={finalArray}
                        isAllChecked={isAllChecked}
                        setIsAllChecked={setIsAllChecked}
                        setCriteria={setCriteria}
                        modified={modified}
                        setModified={setModified}
                        showActionsContractorSupplier={showActionsContractorSupplier}
                />
            )}


            {deleteVehicleShow &&
                <DeleteModal
                    show={deleteVehicleShow}
                    onHide={() => setDeleteVehicleShow(false)}
                    onClickFn={() => deleteSelectedVehicles(selectedList)}
                    data={selectedList}
                    title_modal={t('delete')}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t('vehicles')}
                />
            }

            {(filterDialogShow || finalArray?.length > 0) &&
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement(''); // Clear search input after filtering
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    cleanAdvance={modified}
                    search={search}
                    setSearch={setSearch}
                    setCleanAdvance={setModified}
                    setFinalArray={setFinalArray} //Use for clean all filters in advanced search
                    searchElement={searchElement} // Use for detect search component changes
                />
            }

            <ImportFileModal
                show={importFileShow}
                onHide={() => setImportFileShow(false)}
                onCreationErrors={() => setCreationErrorsShow(true)}
                onCreated={() => setLoaded(true)}
                title_modal={t('import')}
                element_modal={t('vehicles')}
                setModified={setModified}
                model={
                    contractorId !== null
                        ? USER_ACCESS_KEY_MODEL.CONTRACTOR_VEHICLE
                        : supplierId !== null
                            ? USER_ACCESS_KEY_MODEL.SUPPLIER_VEHICLE
                            : USER_ACCESS_KEY_MODEL.EMPLOYEE_VEHICLE
                }
            />
        </>
    );
};

export default AllVehicles;
